import { render, staticRenderFns } from "./LiveStreamingSendGiftModal.vue?vue&type=template&id=7acc7c7c&"
import script from "./LiveStreamingSendGiftModal.vue?vue&type=script&lang=js&"
export * from "./LiveStreamingSendGiftModal.vue?vue&type=script&lang=js&"
import style0 from "./LiveStreamingSendGiftModal.vue?vue&type=style&index=0&id=7acc7c7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports